module.exports = __webpack_public_path__ + "static/media/logo_11.123541f2.png";